(function () {
  if (window.__ga4CartPageListenerActive) return;
  window.__ga4CartPageListenerActive = true;

  function getProductData(variantId) {
    var script = document.querySelector('[data-product-data][data-variant-id="' + variantId + '"]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); }
    catch (e) { return null; }
  }

  function pushEvent(eventName, variantId, quantity) {
    var d = getProductData(variantId);
    if (!d) return;
    var finalPrice = d.price;
    var discount   = Math.max(0, (d.compare_at_price || d.price) - finalPrice);
    var qty        = quantity || 1;
    var gtm        = window.GTMData || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      store_country:  gtm.store_country || "",
      store_language: gtm.store_language || "",
      ecommerce: {
        currency: d.currency,
        value:    finalPrice * qty,
        items: [{
          item_name:  d.title,
          item_id:    d.sku || String(variantId),
          price:      finalPrice,
          item_brand: d.vendor,
          quantity:   qty,
          discount:   discount
        }]
      }
    });
  }

  function getVariantIdFromRow(row) {
    var input = row.querySelector("input[type='number']");
    if (!input) return null;
    // input id è tipo "cart-qty-{key}" dove key può essere "123456789-abc"
    // il variantId è la prima parte numerica
    var match = input.id.replace("cart-qty-", "").match(/^(\d+)/);
    return match ? match[1] : null;
  }

  document.addEventListener("click", function (e) {

    // Plus – aggiungi uno
    var plusBtn = e.target.closest('[aria-label="button-plus"]');
    if (plusBtn) {
      var row = plusBtn.closest(".cart-item");
      if (row) {
        var variantId = getVariantIdFromRow(row);
        if (variantId) pushEvent("add_to_cart", variantId, 1);
      }
      return;
    }

    // Minus – rimuovi uno
    var minusBtn = e.target.closest('[aria-label="button-minus"]');
    if (minusBtn) {
      var row = minusBtn.closest(".cart-item");
      if (row) {
        var variantId = getVariantIdFromRow(row);
        if (variantId) pushEvent("remove_from_cart", variantId, 1);
      }
      return;
    }

    // Remove – rimuovi tutto il prodotto
    var removeBtn = e.target.closest('[aria-label="button-remove"]');
    if (removeBtn) {
      var row = removeBtn.closest(".cart-item");
      if (row) {
        var input = row.querySelector("input[type='number']");
        var qty = input ? (parseInt(input.value, 10) || 1) : 1;
        var variantId = getVariantIdFromRow(row);
        if (variantId) pushEvent("remove_from_cart", variantId, qty);
      }
      return;
    }

  }, true);
})();